import "./App.css";
import { Images } from "./Images";

function App() {
  return (
    <div className=" p-2">
      <Images/>
    </div>
  );
}

export default App;
